
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Chart = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <path d="M16.3,2.8h0A1.8,1.8,0,0,0,14.5.9H10.6A1.8,1.8,0,0,0,8.7,2.7H4.5V22.7H16.7a3.8,3.8,0,0,0,3.8-3.8V2.8Zm-6.1-.1c0-.2.2-.3.4-.3h3.9a.3.3,0,0,1,.3.3V4.6H10.2ZM19,18.9a2.3,2.3,0,0,1-2.3,2.3H6V4.3H8.7V6.1h7.6V4.3H19Z"></path>
            <rect x="8.6" y="12.8" width="7.8" height="1.5"></rect>
            <rect x="8.6" y="9.5" width="7.8" height="1.5"></rect>
            <rect x="8.6" y="16.1" width="3.9" height="1.5"></rect>
          </g>
        </g>
      </g>
    </IconBase>);
};

Chart.defaultProps = {
  title: 'Chart',
};

export default Chart;
